import { Button, Modal, Space, Toast } from 'antd-mobile';
import { DeleteOutline } from 'antd-mobile-icons';
import { useThrottledHandler } from 'App';
import { useI18n } from 'i18n/useI18n';
import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { UserPolyInfoDT } from 'services/apis/sys/user-api';
import VideoListApi, { VideoListDataType } from 'services/apis/usr/video-list-api';

import { clearList as clearCollectList } from 'stores/collectSlice';
import { clearList as clearHistoryList } from 'stores/historySlice';
import { clearRemoveList } from 'stores/removeListSlice';
import { getItemWithExpiration } from 'utils/localStorageUtil';

export type TidyDataType = {
  name: string;
  videoListId: string;
  videoListType: string;
  tidyStatus: boolean;
  handleStatus: any;
};

export default function TidyOptBar(props: TidyDataType) {
  const { t } = useI18n();
  const dispatch = useDispatch();
  const removeList = useSelector((state: any) => state.removeListHandle.value);

  useEffect(() => {
    dispatch(clearRemoveList());
  }, []);

  return (
    <>
      <Space
        justify="between"
        className=" w-full text-base"
      >
        <span>{props.name}</span>
        <Space>
          {/* 清空 */}
          <span
            style={{
              paddingRight: 10,
              borderRight: '1px solid #333',
            }}
            onClick={useThrottledHandler(() => {
              Modal.show({
                title: t('tidy-opt-bar.index.180777-0'),
                content: <div className=" text-base text-center">{'清空' + props.name + '?'}</div>,
                closeOnAction: true,
                actions: [
                  {
                    key: 'submit',
                    text: (
                      <>
                        <div className=" p-2 rounded-md shadow-md bg-orange-400 text-white">确认</div>
                      </>
                    ),
                    onClick: () => {
                      VideoListApi.clear(props.videoListId).then((result) => {
                        if (result.code === 0 && result.successful) {
                          Toast.show(t('tidy-opt-bar.index.180777-2') + props.name);
                          dispatch(props.videoListType === 'collect' ? clearCollectList() : clearHistoryList());
                        } else {
                          Toast.show(
                            t('tidy-opt-bar.index.180777-4') +
                              props.name +
                              t('tidy-opt-bar.index.180777-5') +
                              result.msg
                          );
                        }
                      });
                    },
                  },
                  {
                    key: 'cancel',
                    text: '取消',
                  },
                ],
              });
            })}
          >
            {t('tidy-opt-bar.index.180777-4')}
          </span>
          {/* 整理 */}
          <div
            className=" flex gap-2 items-center justify-center"
            style={props.tidyStatus ? { color: '#f66' } : { color: '#333' }}
            onClick={useThrottledHandler(() => {
              //修改整理状态
              props.handleStatus(!props.tidyStatus);
              if (props.tidyStatus && removeList.length > 0) {
                console.log('确定移除', props, removeList, removeList.length);
                //网络请求删除移除列表里的视频
                VideoListApi.batchRemoveVideo(props.videoListId, removeList).then((result) => {
                  if (result.code === 0 && result.successful) {
                    Toast.show(t('tidy-opt-bar.index.180777-6'));
                    dispatch(clearRemoveList());
                  } else {
                    Toast.show(t('tidy-opt-bar.index.180777-7') + result.msg);
                  }
                });
              }
            })}
          >
            <DeleteOutline />
            <span>{props.tidyStatus ? t('tidy-opt-bar.index.180777-6') : t('tidy-opt-bar.index.180777-8')}</span>
          </div>
        </Space>
      </Space>
    </>
  );
}
